<template>
  <of-menu />
  <div class="pl-16">
    <div class="p-7">
      <router-view />
    </div>
  </div>
</template>
